import { render } from "./LogTask.vue?vue&type=template&id=05b86ae4&scoped=true"
import script from "./LogTask.vue?vue&type=script&lang=js"
export * from "./LogTask.vue?vue&type=script&lang=js"

import "./LogTask.vue?vue&type=style&index=0&id=05b86ae4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b86ae4"]])

export default __exports__